import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';

@Component({
	selector: 'app-language-switcher',
	templateUrl: './lang-switcher.component.html',
	standalone: true,
	styleUrls: ['./lang-switcher.component.scss'],
	imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem],
})
export class LanguageSwitcherComponent {
	private readonly router = inject(Router);

	languageMenu = {
		icon: 'language',
		label: $localize`:@@hub.global.language-label:Langues`,
		subMenu: [
			{
				label: `Français`,
				actionValue: this.switchLanguage.bind(this, 'fr'),
			},
			{
				label: `English`,
				actionValue: this.switchLanguage.bind(this, 'en'),
			},
			{
				label: `Deutsch`,
				actionValue: this.switchLanguage.bind(this, 'de'),
			},
			{
				label: `Polski`,
				actionValue: this.switchLanguage.bind(this, 'pl'),
			},
			{
				label: `Nederlands`,
				actionValue: this.switchLanguage.bind(this, 'nl'),
			},
		],
	};

	public getCurrentRoutePath(): string {
		return this.router.url.split(/[?#]/)[0];
	}

	public switchLanguage(lang: string): void {
		window.location.href = `${window.location.origin}/${lang}${this.getCurrentRoutePath()}`;
	}
}
